import React from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import CircularProgress from '@mui/material/CircularProgress';

export default function SearchField(props) {
  const {
    name,
    label,
    value,
    error = null,
    onChange,
    getOptionLabel,
    options = [],
    disabled = false,
    fullWidth = false,
    handleInputChange,
    style,
    loading = false,
    filterOptions,
    required = false,
    limitTags,
    sx = {},
  } = props;
  return (
    <Autocomplete
      options={options}
      getOptionLabel={getOptionLabel}
      style={style}
      value={value || null}
      disabled={disabled}
      filterOptions={filterOptions}
      fullWidth={fullWidth}
      onInputChange={handleInputChange}
      name={name}
      onChange={(event, newValue) => {
        const e = { target: { name, value: newValue } };
        onChange(e);
      }}
      limitTags={limitTags}
      filterSelectedOptions={false}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          variant="outlined"
          required={required}
          sx={sx}
          error={Boolean(error)}
          helperText={error || ''}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {loading && <CircularProgress color="inherit" size={20} />}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
        />
      )}
    />
  );
}
